<template>
    <div class="sceen2d" :id="id"></div>
</template>

<script>
export default {
    props: {config:Object, shared: {type: Boolean, default: false}},
    data(){
        return {
            id: "cgsTest_" + new Date().getTime()
        }
    },
    mounted (){
      let _this = this
      let CGSMapSDKLoader = window.CGSMapSDKLoader
      CGSMapSDKLoader.accessToken = this.$props.config.accessToken

      // 如果是离线版本，请修改 baseUrl 为当前使用的地址
      CGSMapSDKLoader.baseUrl = this.$props.config.baseUrl
      CGSMapSDKLoader.load(success, fail, '', 'white')
      function success() {
        let CGS = window.CGSMap
        let app = new CGS.App({
          container: _this.id,
          appID: _this.$props.config.appID,
        })

        app.on("load", function () {
        //   new CGS.Widget.UtilsProject()
        })
      }

      function fail(e) {
        console.log(e)
      }
    },
    methods:{
      resize(newHPx, newWPx){
        // console.log(newHPx, newWPx)
      }
    }
    
}
</script>

<style scoped>
.sceen2d{
    width: 100%;
    height: 100%;
}
</style>